module.exports = __webpack_public_path__ + "img/new3.0f783273.png";